<template>
  <div class="main_body">
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <div class="container-fluid">
      <div class="card mt-3 text-white bg-dark">
        <div class="topnav bg-dark">
          <a class="active" href="#" v-on:click="navToogle('publiserPage')"
            >Creators</a
          >
          <a href="#" v-on:click="navToogle('blockPage')">Blocked</a>
        </div>
        <div v-if="publisherPage" class="mt-3">
          <span class="m-3">Creators List</span>
          <div class="card-body">
            <div class="table-responsive">
              <table class="custom_table" style="color: white">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Creator Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Phone</th>
                    <th scope="col">Address</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody v-for="(data, index) in publisherData" :key="index">
                  <tr v-if="data.admin_id != id">
                    <td scope="row">{{ index + 1 }}.</td>
                    <td>{{ data.full_name }}</td>
                    <td>{{ data.email }}</td>
                    <td>{{ data.phone }}</td>
                    <td>{{ data.address }}</td>
                    <td>
                      <h6>
                        <span
                          class="badge bg-success"
                          style="cursor: pointer"
                          v-on:click="navigateChapter(data.id)"
                          >Channel</span
                        >&ensp;
                        <span
                          class="badge bg-danger"
                          style="cursor: pointer"
                          v-on:click="updatePublisher(data.id, 1)"
                          >Block</span
                        >
                      </h6>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-else class="mt-3">
          <span class="m-3"> Blocked Creators</span>
          <div class="card-body">
            <div class="table-responsive">
              <table class="custom_table" style="color: white">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Creator Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Phone</th>
                    <th scope="col">Address</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in blockData" :key="index">
                    <th scope="row">{{ index + 1 }}.</th>
                    <td>{{ data.full_name }}</td>
                    <td>{{ data.email }}</td>
                    <td>{{ data.phone }}</td>
                    <td>{{ data.address }}</td>
                    <td>
                      <h6>
                        <span
                          class="badge bg-success"
                          style="cursor: pointer"
                          v-on:click="updatePublisher(data.id, 0)"
                          >Approved</span
                        >
                      </h6>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
  name: "Publisher",
  components: { Loading },
  data() {
    return {
      publisherData: [],
      blockData: [],
      publisherPage: true,
      id:localStorage.getItem(this.$idKey),
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
    };
  },
  methods: {
    navToogle(status) {
      if (status == "blockPage") {
        this.publisherPage = false;
        console.log(this.publisherPage);
      } else if (status == "publiserPage") {
        this.publisherPage = true;
        console.log(this.publisherPage);
      }
    },

    async getData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/publishers",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          console.log(res.data);
          this.publisherData = res.data;
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },

    async getblockedData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/publishers/blocklist",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          //console.log(res.data)
          this.blockData = res.data;
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },

    async updatePublisher(id, status) {
      //console.log(id)
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.put(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/publishers/status/update/" +
            id,
          {
            deletestatus: status,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          if (res.data.affectedRows == 1) {
            switch (status) {
              case 0: {
                this.$vToastify.info("Publisher Approved");
                this.getblockedData();
                break;
              }
              case 1: {
                this.$vToastify.info("Publisher blocked");
                this.getData();
                break;
              }
            }
            this.getData();
            this.getblockedData();
          } else {
            this.$vToastify.error("Something went worng! please try again.");
          }
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    navigateChapter(id) {
      //console.log(id);
      this.$router.push("/channel/" + id);
    },
  },
  mounted() {
    // use this for get
    this.getData();
    this.getblockedData();
  },
};
</script>

<style scoped>
@import "../../assets/css/audioBook.scss";
</style>
